export default __webpack_public_path__ + "images/ba44d0d9e9609cd00ea0109fdba51d08-amazonpay-logo-big-yellow.svg";